import { render, staticRenderFns } from "./ProductStockInfoModal.vue?vue&type=template&id=68374f79&scoped=true"
import script from "./ProductStockInfoModal.vue?vue&type=script&lang=js"
export * from "./ProductStockInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ProductStockInfoModal.vue?vue&type=style&index=0&id=68374f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68374f79",
  null
  
)

export default component.exports